'use client';

import React from 'react';
import Multiselect from '~/components/Multiselect';
import { api } from '~/utils/api';
import { AgentModelUseCase } from '@prisma/client';

export type DefaultEvaluationTypeProps = {
  readOnly: boolean;
  onUpdate: (selected: string[]) => void;
  allowedEvaluationTypeIds: string[];
  useCase?: AgentModelUseCase;
  label?: React.ReactNode;
};

export default function AllowedEvaluationTypes(props: DefaultEvaluationTypeProps) {
  const { readOnly, onUpdate, allowedEvaluationTypeIds, useCase, label } = props;

  const { data: allDocumentEvaluationTypes } =
    api.policyEngine.getAllDocumentEvaluationTypes.useQuery(
      { useCase: useCase! },
      { enabled: !!useCase },
    );

  return (
    <Multiselect
      label={label}
      options={
        allDocumentEvaluationTypes?.documentEvaluationTypes.map((t) => ({
          label: t.name,
          value: t.id,
        })) || []
      }
      selected={allowedEvaluationTypeIds}
      readOnly={readOnly}
      onChange={onUpdate}
      placeholder="Select evaluation types…"
      className="w-full max-w-none [&_button]:max-w-none"
    />
  );
}
